import React, { useState } from 'react';

import { CollapserIcon } from './CollapserIcon';

type CollapserProps = {
  header: React.ReactNode;
  children: React.ReactNode;

  headerClassName?: string;
  defaultCollapsed?: boolean;
};

const Collapser: React.FC<CollapserProps> = ({
  header,
  children,

  headerClassName = 'font-medium text-tiny text-header',
  defaultCollapsed = false,
}) => {
  const [show, setShow] = useState(!defaultCollapsed);

  return (
    <div className="flex flex-col">
      <div
        className="flex flex-row cursor-pointer items-center"
        onClick={() => setShow(s => !s)}
      >
        <div className={headerClassName}>{header}</div>
        <div className="flex items-center justify-center ml-sm">
          <CollapserIcon show={show} />
        </div>
      </div>
      {!!show && children}
    </div>
  );
};

export default React.memo(Collapser) as typeof Collapser;
